export default __webpack_public_path__ + "static/logo-white-97b3a3be24b978d5e1dee2f003fa0114.svg";